// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReMenShengXiaoTongJi[data-v-8fad0d1e]{width:100%;height:700px;background-color:#fff}.echarts[data-v-8fad0d1e]{width:100%;height:80%!important}.chart-container[data-v-8fad0d1e]{height:600px}", ""]);
// Exports
module.exports = exports;
